<kendo-dialog title="Add New Student" *ngIf="showDialog" (close)="hideDialog.emit(); resetForm()" [height]="'90vh'"
    [minWidth]="1166" [width]="'90vw'" [maxHeight]="1100" #dialog
    [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
    <kendo-loader type="converging-spinner" size="large" *ngIf="loading" class="loader"></kendo-loader>

    <div *ngIf="form">
        <form [formGroup]="form">
            <!-- Grid to display search results -->
            <div>
                <kendo-grid *ngIf="isShowGrid" #grid class="student-search-grid" [kendoGridBinding]="duplicateGridData"
                    scrollable="none" [pageSize]="10" [pageable]="true" [sortable]="true" [groupable]="false"
                    [resizable]="false" [columnMenu]="{ filter: true, columnChooser: false }" [loading]="loading"
                    [selectable]="false" [sort]="[{ field: 'studentName', dir: 'asc' }]">

                    <kendo-grid-column field="" [sortable]="false" [width]="40" headerClass="action-column"
                        title="Actions">
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            <div kendoToolTip
                                [title]="!dataItem.isPreSchool ? 'There are no actions available for this student.' : '' "
                                showOn="hover">
                                <button kendoButton #anchor [svgIcon]="actionIcon"
                                    (click)="openMenu(dataItem, rowIndex)" fillMode="clear" size="none"
                                    [disabled]="!dataItem?.isPreSchool"> </button>
                            </div>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="studentName" title="Student" [width]="250">
                        <ng-template kendoGridCellTemplate let-data>
                            <div class="name-container">
                                <div class="student-name k-text-ellipsis">{{ data.studentName | titlecase }}</div>
                            </div>
                            <div class="student-id">{{ data.nycId }}</div>
                            <!-- TODO: The size of the kendo chips need to be changed to small, already confirmed this with Michelle -->
                            <div class="name-container"> <kendo-chip
                                    *ngIf="data.atsStatus === 'D' || data.atsStatus === 'DISCHARGED'" rounded="full"
                                    size="large" fillMode="solid" themeColor="warning" class="status-chip closed-chip"
                                    [selected]="true" label="ATS: Discharged">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.atsStatus === 'ACTIVE' || data.atsStatus === 'A'" rounded="full"
                                    size="large" fillMode="solid" themeColor="success" class="status-chip"
                                    [selected]="true" label="ATS: Active">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.refStatus > 0 && data.refStatus !== 7" rounded="full"
                                    size="large" fillMode="solid" themeColor="success" class="status-chip active-chip"
                                    [selected]="true" label="Special Education Status: Active">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.refStatus === 7" rounded="full" size="large" fillMode="solid"
                                    themeColor="warning" class="status-chip closed-chip" [selected]="true"
                                    label="Special Education Status: Inactive">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.ineligibleSE" rounded="full" size="large" fillMode="solid"
                                    themeColor="warning" class="status-chip active-chip" [selected]="true"
                                    label="Special Education Status: Ineligible">
                                </kendo-chip>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="dateOfBirthUnixTimestamp" title="DOB" [width]="100" [resizable]="false">
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            {{dataItem.dateOfBirth | formatDate}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="gender" title="Gender" [width]="100" [resizable]="false">
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            {{dataItem.gender | titlecase}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="grade" title="Grade" [width]="90" [resizable]="false"></kendo-grid-column>
                    <kendo-grid-column field="school" title="School" [width]="200"></kendo-grid-column>

                    <ng-template kendoGridNoRecordsTemplate>
                        <p *ngIf="!loading">No Student records available</p>
                    </ng-template>

                    <ng-template kendoGridLoadingTemplate>
                        <div class="loading-container">
                            <kendo-loader type="converging-spinner" size="medium"></kendo-loader>
                        </div>
                    </ng-template>
                </kendo-grid>

                <kendo-contextmenu #gridmenu [items]="duplicateStudent?.actions" (select)="onSelect($event)"
                    showOn="click"></kendo-contextmenu>

            </div>

            <!-- Form to create a new student -->
            <div class="subsection">
                <h4 class="subsection__heading">Basic Information</h4>

                <div class="contact-details-container">
                    <div class="info-container">
                        <kendo-formfield>
                            <kendo-floatinglabel text="First Name *">
                                <kendo-textbox formControlName="firstName" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Middle Name">
                                <kendo-textbox formControlName="middleName" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Last Name *">
                                <kendo-textbox formControlName="lastName" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Date of Birth *">
                                <kendo-datepicker calendarType="classic" formControlName="dob" [max]="threeYearsAgo"
                                    placeholder="MM/DD/YYYY" format="MM/dd/yyyy" [clearButton]="true"
                                    [min]="minPreschoolDob"></kendo-datepicker>
                            </kendo-floatinglabel>
                            <kendo-formerror *ngIf="form.get('dob').hasError('required')">Required</kendo-formerror>
                            <kendo-formerror *ngIf="form.get('dob').hasError('minError')">Does not meet age
                                requirement for initial referral</kendo-formerror>
                            <kendo-formerror *ngIf="form.get('dob').hasError('maxError')">Does not meet age
                                requirement for initial referral</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Gender *">
                                <kendo-dropdownlist [data]="referenceData.sex" [textField]="'description'"
                                    [valueField]="'value'" formControlName="gender">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>
                    </div>

                    <div class="info-container">
                        <kendo-formfield>
                            <kendo-floatinglabel text="Student Phone Number">
                                <kendo-maskedtextbox formControlName="studentPhoneNumber"
                                    mask="(000) 000-0000"></kendo-maskedtextbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>{{
                                form.get('studentPhoneNumber')?.errors?.validatePhoneNumberMaskedTextBox?.message
                                }}</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Student Email">
                                <kendo-textbox formControlName="studentEmail" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="divider"></div>

            <!-- Housing Information -->
            <div class="subsection">
                <h4 class="subsection__heading">Housing</h4>

                <div class="contact-details-container">
                    <div class="info-container">
                        <kendo-formfield>
                            <kendo-floatinglabel text="Street Number *">
                                <kendo-textbox formControlName="streetNumber" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield class="street-city">
                            <kendo-floatinglabel text="Street Name *">
                                <kendo-textbox formControlName="streetName" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Apartment Number">
                                <kendo-textbox formControlName="apartmentNumber" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Home Borough *">
                                <kendo-dropdownlist [data]="referenceData.borough" [textField]="'description'"
                                    [valueField]="'id'" formControlName="homeBorough">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>
                    </div>

                    <div class="info-container">
                        <kendo-formfield>
                            <kendo-floatinglabel [text]="isHomeDistrictRequired ? 'Home District *' : 'Home District'">
                                <kendo-dropdownlist [data]="referenceData.district" [textField]="'description'"
                                    [valueField]="'id'" formControlName="homeDistrict">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield class="street-city">
                            <kendo-floatinglabel text="City *">
                                <kendo-textbox formControlName="city"
                                    (keypress)="allowCityCharacters($event)" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="State *">
                                <kendo-dropdownlist [data]="referenceData.state" [textField]="'description'"
                                    [valueField]="'id'" formControlName="state">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Zip *">
                                <kendo-textbox formControlName="zip" appMinLength="5" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                            <kendo-formhint>Formats: 12345, 12345-6789, 12345 6789, or
                                123456789</kendo-formhint>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="divider"></div>

            <!-- Parent/Guardian section -->
            <div class="subsection">
                <h4 class="subsection__heading">Parent/Guardian</h4>

                <div class="contact-details-container">
                    <div class="info-container">
                        <kendo-formfield>
                            <kendo-floatinglabel text="Relationship *">
                                <kendo-dropdownlist [data]="referenceData.relationship" [textField]="'description'"
                                    [valueField]="'id'" formControlName="guardianRelationship">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="First Name *">
                                <kendo-textbox formControlName="guardianFirstName" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Last Name *">
                                <kendo-textbox formControlName="guardianLastName" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>Required</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Spoken Language">
                                <kendo-dropdownlist [data]="referenceData.language" [textField]="'description'"
                                    [valueField]="'id'" formControlName="guardianSpokenLanguage">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Written Language ">
                                <kendo-dropdownlist [data]="referenceData.language" [textField]="'description'"
                                    [valueField]="'id'" formControlName="guardianWrittenLanguage">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                        </kendo-formfield>
                    </div>


                    <div class="info-container">
                        <kendo-formfield>
                            <kendo-floatinglabel text="Cell Phone">
                                <kendo-maskedtextbox formControlName="guardianCellPhone" mask="(000) 000-0000">
                                </kendo-maskedtextbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>{{form.get('guardianCellPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Work Phone">
                                <kendo-maskedtextbox formControlName="guardianWorkPhone" mask="(000) 000-0000">
                                </kendo-maskedtextbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>{{form.get('guardianWorkPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Email">
                                <kendo-textbox formControlName="guardianEmail" [clearButton]="true"></kendo-textbox>
                            </kendo-floatinglabel>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="Home Phone">
                                <kendo-maskedtextbox formControlName="guardianHomePhone"
                                    mask="(000) 000-0000"></kendo-maskedtextbox>
                            </kendo-floatinglabel>
                            <kendo-formerror>{{form.get('guardianHomePhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <kendo-dialog-actions [layout]="'stretched'">
        <button kendoButton themeColor="primary" fillMode="solid" [disabled]="form?.invalid || loading"
            (click)="submit(false)">
            {{isShowGrid? 'Create Duplicate' : 'Submit'}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>